import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Cache the roster in-module — never changes between page loads, and
 * /panel/roster is a public endpoint so it's fine to fetch once and share.
 */
let CACHE = null;
let PROMISE = null;

export function usePanelRoster() {
  const [roster, setRoster] = useState(CACHE);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (CACHE) return;
    if (!PROMISE) {
      PROMISE = api
        .get("/panel/roster")
        .then((r) => {
          CACHE = r.data?.panelists || [];
          return CACHE;
        })
        .catch((e) => {
          setError(e);
          PROMISE = null;
          return [];
        });
    }
    PROMISE.then((data) => setRoster(data));
  }, []);

  return { roster: roster || [], loading: roster === null && !error, error };
}
